import status from '@cordel/helpers/colors/proposals';

const STATUS = {
  check: 'checagem',
  analyze: 'análise',
  hang: 'pendente',
  restrict: 'restrição',
  preapprove: 'pré_aprovada',
  approve: 'aprovada',
  refuse: 'recusada',
  invoice: 'faturada',
  dismiss: 'desistencia',
};

Object.keys(STATUS).forEach((i) => {
  STATUS[i] = {
    identifier: STATUS[i],
    label: status(i),
    value: i,
  };
});

export default STATUS;
